import { render } from "./carrito.vue?vue&type=template&id=6fbedfd3&scoped=true"
import script from "./carrito.vue?vue&type=script&lang=js"
export * from "./carrito.vue?vue&type=script&lang=js"

import "./carrito.vue?vue&type=style&index=0&id=6fbedfd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbedfd3"]])

export default __exports__